import {
    GET_TELESALE_FOLLOW_UPS,
    GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER
} from '@/redux/actions/types';


/**
 * initial state
 */
const INIT_STATE = {
    telesaleFollowUps: [],            // danh sách telesale_follow_ups
    telesaleFollowUpsByCustomer: [],  // telesale_follow_ups theo customer
    statistical: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_TELESALE_FOLLOW_UPS: {
            return {
                ...state,
                telesaleFollowUps: action.payload?.data || [],
                statistical: action.payload?.statistical || null,
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1),
                    total: parseInt(action.payload?.total || 0),
                    perPage: parseInt(action.payload?.per_page || 30),
                }
            };
        }

        case GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER: {
            return {
                ...state,
                telesaleFollowUpsByCustomer: action.payload || []
            };
        }

        default:
            return state;
    }
};
